// extracted by mini-css-extract-plugin
module.exports = {"fialie":"fialie","bcf7ah9":"bcf7ah9"};